import React from "react";
import FieldRow from "../../../FieldRow";
import { formatCvv } from "../../../../utils/creditCards";

function MasterpassFormFields({ validate, onChange, data, csc }) {
    return (
        <React.Fragment>
          <FieldRow type="email" label="Email"
                    value={data.contact_email}
          />
          <FieldRow label="Nombre y apellido"
                    value={data.cardholder}
          />
          <FieldRow label="Número de la tarjeta"
                      className={'card-' + data.card_brand}
                      value={data.credit_card}
          />
          <div className="row">
            <div className="col-6">
              <FieldRow label="CVV"
                        onChange={(e) => onChange('csc', e.target.value)}
                        onBlur={() => validate('csc')}
                        value={formatCvv(csc.value)}
                        valid={csc.valid}
                        validationError={csc.validationError}
              />
            </div>
          </div>
        </React.Fragment>
    );
}

export default MasterpassFormFields;